<template>
  <div class="public" ref="public">
    <div class="public-header">
      <h2 class="public-header__name">多伦多常用电话</h2>
      <div class="public-header__tip">
        <strong>加拿大本地：</strong>
        <span>城市区号+电话</span>
        <strong>美国：</strong>
        <span>1+城市区号+电话</span>
        <strong>香港：</strong>
        <span>011+852+2+电话</span>
        <strong>中国大陆：</strong>
        <span>011+86+城市区号+电话</span>
        <strong>台湾：</strong>
        <span>011+886+城市区号+电话</span>
      </div>
    </div>
    <!-- 标签页 -->
    <div class="public-tab__list">
      <button
        class="public-tab__item"
        v-for="(item, i) in tabList"
        :key="i"
        :class="{ active: tabIndex == i }"
        @click="tabIndex = i"
      >
        <i :class="item.icon"></i><span>{{ item.name }}</span>
      </button>
    </div>
    <!-- 紧急求救 -->
    <div class="content-section" v-show="tabIndex == 0">
      <div class="content-block">
        <h3 class="content-header"><strong>紧急求助热线</strong><span>（紧急求救）</span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">多伦多警察局</div>
            <div class="content-value">416-808-2222</div>
          </li>
          <li class="content-item">
            <div class="content-label">犯罪信息举报</div>
            <div class="content-value">800-222-8477</div>
          </li>
          <li class="content-item">
            <div class="content-label">多伦多火警服务</div>
            <div class="content-value">416-338-9050 / 3-1-1</div>
          </li>
          <li class="content-item">
            <div class="content-label">应急管理办公室（Emergency Management center）</div>
            <div class="content-value">416-392-4554</div>
          </li>
          <li class="content-item">
            <div class="content-label">中毒咨询中心</div>
            <div class="content-value">800-268-9017</div>
          </li>
          <li class="content-item">
            <div class="content-label">儿童求助电话（kids help）</div>
            <div class="content-value">800-668-6868</div>
          </li>
          <li class="content-item">
            <div class="content-label">儿童援助（children's aid）</div>
            <div class="content-value">416-924-4646</div>
          </li>
          <li class="content-item">
            <div class="content-label">多伦多求助中心（Distress Centre of Toronto）</div>
            <div class="content-value">416-598-1121</div>
          </li>
        </ul>
        <h3 class="content-header"><strong>援助热线</strong><span>（紧急求救）</span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">租客纠纷</div>
            <div class="content-value">416-645-8080</div>
          </li>
          <li class="content-item">
            <div class="content-label">受害者援助 Victim Assistance</div>
            <div class="content-value">416-325-3265</div>
          </li>
          <li class="content-item">
            <div class="content-label">人权侵害 ontario human rights</div>
            <div class="content-value">（416） 326-9511</div>
          </li>
          <li class="content-item">
            <div class="content-label">法律援助 legal aid</div>
            <div class="content-value">1-800-668-8258</div>
          </li>
          <li class="content-item">
            <div class="content-label">受侵妇女（Assaulted Women's Helpline）</div>
            <div class="content-value">416-863-0511</div>
          </li>
          <li class="content-item">
            <div class="content-label">虐待妇女</div>
            <div class="content-value">416-759-0138 / 800-387-8603</div>
          </li>
          <li class="content-item">
            <div class="content-label">性侵犯</div>
            <div class="content-value">416-597-8808</div>
          </li>
          <li class="content-item">
            <div class="content-label">安省法律援助</div>
            <div class="content-value">416-598-0200</div>
          </li>
        </ul>
      </div>

      <div class="content-block">
        <h3 class="content-header"><strong>医院急救</strong><span>（紧急求救）</span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">儿童医院（Hospital For Sick Children）</div>
            <div class="content-value">416-813-1500</div>
          </li>
          <li class="content-item">
            <div class="content-label">西奈山医院（Mount Sinai Hospital）</div>
            <div class="content-value">416-586-5054</div>
          </li>
          <li class="content-item">
            <div class="content-label">士嘉堡兆康医院（Scarborough Centenary Hospital）</div>
            <div class="content-value">416-284-8131</div>
          </li>
          <li class="content-item">
            <div class="content-label">士嘉堡慈恩医院（Scarborough Grace Hospital）</div>
            <div class="content-value">416-495-2400</div>
          </li>
          <li class="content-item">
            <div class="content-label">士嘉堡综合医院（Scarborough General Hospital）</div>
            <div class="content-value">416-438-2911</div>
          </li>
          <li class="content-item">
            <div class="content-label">Michael Garron Hospital（前多伦多东区综合医院）</div>
            <div class="content-value">416-461-8272</div>
          </li>
          <li class="content-item">
            <div class="content-label">多伦多西区医院（Toronto Western Hospital）</div>
            <div class="content-value">416-603-2581</div>
          </li>
          <li class="content-item">
            <div class="content-label">北约克综合医院 North York General Hospital</div>
            <div class="content-value">416-756-4994</div>
          </li>
          <li class="content-item">
            <div class="content-label">Sunnybrook Hospital（新宁健康科学中心）</div>
            <div class="content-value">416-480-6100</div>
          </li>
        </ul>
        <h3 class="content-header"><strong>消防</strong><span>（紧急求救）</span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">怡陶碧谷（Etobicoke）</div>
            <div class="content-value">416-338-9450</div>
          </li>
          <li class="content-item">
            <div class="content-label">北约克（North York）</div>
            <div class="content-value">416-338-9150</div>
          </li>
          <li class="content-item">
            <div class="content-label">士嘉堡（Scarborough）</div>
            <div class="content-value">416-338-9250</div>
          </li>
          <li class="content-item">
            <div class="content-label">多伦多（Toronto Downtown）</div>
            <div class="content-value">416-338-9350</div>
          </li>
          <li class="content-item">
            <div class="content-label">约克（York）</div>
            <div class="content-value">416-338-9450</div>
          </li>
        </ul>
        <h3 class="content-header"><strong>毒品</strong><span>（紧急求救）</span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">安大略毒品中心</div>
            <div class="content-value">416-813-5900</div>
          </li>
          <li class="content-item">
            <div class="content-label">污染泄露</div>
            <div class="content-value">416-325-3000</div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 政府资讯 -->
    <div class="content-section" v-show="tabIndex == 1">
      <div class="content-block">
        <h3 class="content-header"><strong>移民部及使领馆</strong><span>（政府资讯）</span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">联邦公民及移民部 CIC</div>
            <div class="content-value">888-242-2100</div>
          </li>
          <li class="content-item">
            <div class="content-label">移民难民委员会</div>
            <div class="content-value">416-973-6261</div>
          </li>
          <li class="content-item">
            <div class="content-label">中国驻多伦多领事馆</div>
            <div class="content-value">416-964-8861 / 416-964-7260</div>
          </li>
          <li class="content-item">
            <div class="content-label">中国驻温哥华领事馆</div>
            <div class="content-value">604-734-7492 / 604-736-5188</div>
          </li>
          <li class="content-item">
            <div class="content-label">中国驻加拿大大使馆电话</div>
            <div class="content-value">613-789-3434 / 613-791-0511</div>
          </li>
          <li class="content-item">
            <div class="content-label">中国驻卡尔加里总领馆电话</div>
            <div class="content-value">403-264-3322</div>
          </li>
          <li class="content-item">
            <div class="content-label">加拿大海关</div>
            <div class="content-value">800-461-9999</div>
          </li>
          <li class="content-item">
            <div class="content-label">加拿大护照办公室</div>
            <div class="content-value">800-567-6868</div>
          </li>
          <li class="content-item">
            <div class="content-label">卑诗省厅级政府部门咨询电话</div>
            <div class="content-value">800-663-7867/604-660-2421</div>
          </li>
          <li class="content-item">
            <div class="content-label">卑诗省医疗保险</div>
            <div class="content-value">604-683-7151/800-663-7100</div>
          </li>
        </ul>
      </div>

      <div class="content-block">
        <h3 class="content-header"><strong>社区及福利资源</strong><span>（政府资讯）</span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">牛奶金</div>
            <div class="content-value">800-387-1193</div>
          </li>
          <li class="content-item">
            <div class="content-label">老人金/退休金</div>
            <div class="content-value">800-277-9914</div>
          </li>
          <li class="content-item">
            <div class="content-label">就业保险金（失业金）</div>
            <div class="content-value">800-206-7218</div>
          </li>
          <li class="content-item">
            <div class="content-label">安省（多伦多）劳工厅</div>
            <div class="content-value">416-326-7160</div>
          </li>
          <li class="content-item">
            <div class="content-label">卑诗省厅级政府部门咨询热线</div>
            <div class="content-value">604-660-2421</div>
          </li>
          <li class="content-item">
            <div class="content-label">安省医疗保险查询热线</div>
            <div class="content-value">800-268-1154</div>
          </li>
          <li class="content-item">
            <div class="content-label">卑诗省医疗保险查询热线</div>
            <div class="content-value">800-663-7100</div>
          </li>
          <li class="content-item">
            <div class="content-label">加拿大税务局</div>
            <div class="content-value">800-959-8281</div>
          </li>
          <li class="content-item">
            <div class="content-label">多伦多廉租/老人屋</div>
            <div class="content-value">416-981-6111</div>
          </li>
          <li class="content-item">
            <div class="content-label">卑诗省房屋局</div>
            <div class="content-value">604-433-1711</div>
          </li>
          <li class="content-item">
            <div class="content-label">加拿大国会</div>
            <div class="content-value">866-599-4999</div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 电信上网 -->
    <div class="content-section" v-show="tabIndex == 2">
      <div class="content-block">
        <h3 class="content-header"><strong>Rogers</strong><span>（电信上网）</span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">Rogers 移动电话中文服务热线</div>
            <div class="content-value">800-828-9828</div>
          </li>
          <li class="content-item">
            <div class="content-label">Rogers 有线电视中文服务热线</div>
            <div class="content-value">800-787-7953</div>
          </li>
          <li class="content-item">
            <div class="content-label">Rogers 高速上网中文服务热线</div>
            <div class="content-value">800-787-7953</div>
          </li>
        </ul>
        <h3 class="content-header"><strong>Fido</strong><span>（电信上网）</span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">Fido 移动电话中文服务热线</div>
            <div class="content-value">866-888-3436</div>
          </li>
        </ul>
        <h3 class="content-header"><strong>italkbb</strong><span>（电信上网）</span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">italkbb 中文服务热线</div>
            <div class="content-value">1-877-482-5503</div>
          </li>
        </ul>
        <h3 class="content-header"><strong>其他</strong><span>（电信上网） </span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">电话故障修理热线</div>
            <div class="content-value">611</div>
          </li>
          <li class="content-item">
            <div class="content-label">电话查询</div>
            <div class="content-value">411</div>
          </li>
          <li class="content-item">
            <div class="content-label">长途电话查询</div>
            <div class="content-value">（+1）1212（免费，需在前面加拨当地区号）</div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <h3 class="content-header"><strong>Bell</strong><span>（电信上网） </span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">Bell 移动电话中文服务热线</div>
            <div class="content-value">888-884-8333</div>
          </li>
          <li class="content-item">
            <div class="content-label">Bell 住宅电话中文服务热线</div>
            <div class="content-value">800-715-1888</div>
          </li>
          <li class="content-item">
            <div class="content-label">Bell 商用电话中文服务热线</div>
            <div class="content-value">888-272-1888</div>
          </li>
          <li class="content-item">
            <div class="content-label">TV 电视中文服务热线</div>
            <div class="content-value">888-759-3474（按3广东话，按4国语）</div>
          </li>
        </ul>
        <h3 class="content-header"><strong>Telus</strong><span>（电信上网） </span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">Telus 移动电话中文服务热线</div>
            <div class="content-value">866-558-2273</div>
          </li>
        </ul>
        <h3 class="content-header"><strong>英文客服 </strong><span>（电信上网） </span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">Freedom</div>
            <div class="content-value">1-877-946-3184</div>
          </li>
          <li class="content-item">
            <div class="content-label">Virgin Mobile</div>
            <div class="content-value">1-888-999-2321</div>
          </li>
          <li class="content-item">
            <div class="content-label">Chatr</div>
            <div class="content-value">1-800-485-9745</div>
          </li>
          <li class="content-item">
            <div class="content-label">Koodo</div>
            <div class="content-value">866-995-6636</div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 银行服务 -->
    <div class="content-section" v-show="tabIndex == 3">
      <div class="content-block">
        <h3 class="content-header"><strong>银行服务 - 中文热线</strong><span>（银行服务） </span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">TD Bank 中文服务热线</div>
            <div class="content-value">800-387-2828 粤/国</div>
          </li>
          <li class="content-item">
            <div class="content-label">TD Bank VISA 中文服务热线</div>
            <div class="content-value">877-233-5558</div>
          </li>
          <li class="content-item">
            <div class="content-label">TD Bank 互惠基金中文热线</div>
            <div class="content-value">800-387-2828</div>
          </li>
          <li class="content-item">
            <div class="content-label">BMO 中文服务热线</div>
            <div class="content-value">888-828-7288（国） 888-883-1828（粤）</div>
          </li>
          <li class="content-item">
            <div class="content-label">SCOTIA 中文服务热线</div>
            <div class="content-value">800-830-8080</div>
          </li>
          <li class="content-item">
            <div class="content-label">Royal Bank 中文服务热线</div>
            <div class="content-value">888-769-2598</div>
          </li>
          <li class="content-item">
            <div class="content-label">CIBC 中文服务热线</div>
            <div class="content-value">888-298-8822（国） 888-898-2828（粤）</div>
          </li>
          <li class="content-item">
            <div class="content-label">HSBC 中文服务热线</div>
            <div class="content-value">888-828-7288</div>
          </li>
          <li class="content-item">
            <div class="content-label">HSBC 互惠基金中文服务热线</div>
            <div class="content-value">1-800-830-8888</div>
          </li>
          <li class="content-item">
            <div class="content-label">Bank of China 中国银行加拿大分行</div>
            <div class="content-value">多伦多电话 416-971-8806 温哥华 604-683-1088</div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <h3 class="content-header"><strong>银行服务 - 英文热线</strong><span>（银行服务） </span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">TD Bank（EasyLine） 英文服务热线</div>
            <div class="content-value">866-222-3456</div>
          </li>
          <li class="content-item">
            <div class="content-label">Royal Bank 英文服务热线</div>
            <div class="content-value">800-769-2520</div>
          </li>
          <li class="content-item">
            <div class="content-label">BMO 英文服务热线</div>
            <div class="content-value">877-225-5266</div>
          </li>
          <li class="content-item">
            <div class="content-label">SCOTIA 英文服务热线</div>
            <div class="content-value">800-472-6842</div>
          </li>
          <li class="content-item">
            <div class="content-label">CIBC 英文服务热线</div>
            <div class="content-value">800-465-2422</div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 日常服务 -->
    <div class="content-section" v-show="tabIndex == 4">
      <div class="content-block">
        <h3 class="content-header"><strong>生活常用电话</strong><span>（日常服务）</span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">Canada Post 邮政服务</div>
            <div class="content-value">1-866-607-6301</div>
          </li>
          <li class="content-item">
            <div class="content-label">中奖彩票号码查询</div>
            <div class="content-value">416-870-8946</div>
          </li>
          <li class="content-item">
            <div class="content-label">出生证明查询</div>
            <div class="content-value">800-461-2156</div>
          </li>
          <li class="content-item">
            <div class="content-label">公司注册</div>
            <div class="content-value">416-314-8880</div>
          </li>
          <li class="content-item">
            <div class="content-label">托儿查询</div>
            <div class="content-value">416-327-9979</div>
          </li>
          <li class="content-item">
            <div class="content-label">护照及签证查询</div>
            <div class="content-value">416-973-3251</div>
          </li>
          <li class="content-item">
            <div class="content-label">驾驶执照查询</div>
            <div class="content-value">416-235-2999</div>
          </li>
          <li class="content-item">
            <div class="content-label">健康保险查询</div>
            <div class="content-value">800-268-1154</div>
          </li>
          <li class="content-item">
            <div class="content-label">房租管制查询</div>
            <div class="content-value">416-921-9494</div>
          </li>
          <li class="content-item">
            <div class="content-label">结婚证书申请</div>
            <div class="content-value">800-461-2156</div>
          </li>
          <li class="content-item">
            <div class="content-label">公证服务</div>
            <div class="content-value">416-837-3978</div>
          </li>
          <li class="content-item">
            <div class="content-label">车辆牌照查询</div>
            <div class="content-value">416-235-2999 / 416-929-5400</div>
          </li>
          <li class="content-item">
            <div class="content-label">就业和社会服务</div>
            <div class="content-value">416-392-8623</div>
          </li>
          <li class="content-item">
            <div class="content-label">牌照和许可</div>
            <div class="content-value">416-392-3000</div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <h3 class="content-header"><strong>市政</strong><span>（日常服务）</span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">Service Ontario</div>
            <div class="content-value">416-326-1234</div>
          </li>
          <li class="content-item">
            <div class="content-label">City of Toronto</div>
            <div class="content-value">311</div>
          </li>
          <li class="content-item">
            <div class="content-label">City of Markham</div>
            <div class="content-value">905-477-5530</div>
          </li>
          <li class="content-item">
            <div class="content-label">Richmond Hill</div>
            <div class="content-value">905-771-8800</div>
          </li>
          <li class="content-item">
            <div class="content-label">Town of Aurora</div>
            <div class="content-value">905-727-1375</div>
          </li>
          <li class="content-item">
            <div class="content-label">City of Vaughan</div>
            <div class="content-value">905-832-2281</div>
          </li>
          <li class="content-item">
            <div class="content-label">查询社区资源</div>
            <div class="content-value">211</div>
          </li>
          <li class="content-item">
            <div class="content-label">多伦多教育局</div>
            <div class="content-value">416-396-2000</div>
          </li>
          <li class="content-item">
            <div class="content-label">约克郡教育局</div>
            <div class="content-value">905-727-3141</div>
          </li>
        </ul>
        <h3 class="content-header"><strong>华人社区/组织 </strong><span>（日常服务）</span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">多华会 TCCSA</div>
            <div class="content-value">416-977-4026</div>
          </li>
          <li class="content-item">
            <div class="content-label">活贤社（WoodGreen Community Services）</div>
            <div class="content-value">416-469-5211</div>
          </li>
          <li class="content-item">
            <div class="content-label">华人及东南亚群体法律援助</div>
            <div class="content-value">416-971-9674</div>
          </li>
          <li class="content-item">
            <div class="content-label">加拿大海外移民服务中心多伦多分部</div>
            <div class="content-value">416-593-8008</div>
          </li>
          <li class="content-item">
            <div class="content-label">华咨处</div>
            <div class="content-value">416-293-4565</div>
          </li>
          <li class="content-item">
            <div class="content-label">加拿大中国专业人士协会 CPAC</div>
            <div class="content-value">416-298-7885</div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 维修挂失 -->
    <div class="content-section" v-show="tabIndex == 5">
      <div class="content-block">
        <h3 class="content-header"><strong>电力维修</strong><span>（维修挂失） </span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">煤气公司 Enbridge</div>
            <div class="content-value">877-362-7434</div>
          </li>
          <li class="content-item">
            <div class="content-label">水电公司 Toronto Hydro</div>
            <div class="content-value">416-542-8000</div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <h3 class="content-header"><strong>挂失热线</strong><span>（维修挂失）</span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">驾驶执照</div>
            <div class="content-value">416-235-2999</div>
          </li>
          <li class="content-item">
            <div class="content-label">SIN 卡</div>
            <div class="content-value">888-495-8501</div>
          </li>
          <li class="content-item">
            <div class="content-label">公民卡</div>
            <div class="content-value">888-242-2100</div>
          </li>
          <li class="content-item">
            <div class="content-label">加拿大护照</div>
            <div class="content-value">800-567-6868</div>
          </li>
          <li class="content-item">
            <div class="content-label">安省健康卡</div>
            <div class="content-value">866-532-3161</div>
          </li>
          <li class="content-item">
            <div class="content-label">TTC 失物招领</div>
            <div class="content-value">416-393-4100</div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 公共交通 -->
    <div class="content-section" v-show="tabIndex == 6">
      <div class="content-block">
        <h3 class="content-header"><strong>常用交通工具查询 </strong><span>（公共交通） </span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">市内交通查询</div>
            <div class="content-value">416-599-9090</div>
          </li>
          <li class="content-item">
            <div class="content-label">TTC 查询</div>
            <div class="content-value">416-393-4636</div>
          </li>
          <li class="content-item">
            <div class="content-label">Go Transit</div>
            <div class="content-value">416-869-3200</div>
          </li>
          <li class="content-item">
            <div class="content-label">Via Rail 火车</div>
            <div class="content-value">888-842-7245</div>
          </li>
          <li class="content-item">
            <div class="content-label">中央岛轮渡</div>
            <div class="content-value">416-392-8193</div>
          </li>
          <li class="content-item">
            <div class="content-label">Greyhound 汽车</div>
            <div class="content-value">416-367-8747</div>
          </li>
          <li class="content-item">
            <div class="content-label">长途汽车总站</div>
            <div class="content-value">416-393-7911</div>
          </li>
          <li class="content-item">
            <div class="content-label">航空公司 Air Canada Asia Desk</div>
            <div class="content-value">400-811-2001</div>
          </li>
          <li class="content-item">
            <div class="content-label">Canadian Airlines</div>
            <div class="content-value">888-247-2262</div>
          </li>
          <li class="content-item">
            <div class="content-label">Pearson 国际机场</div>
            <div class="content-value">416-247-7678</div>
          </li>
          <li class="content-item">
            <div class="content-label">加航中文服务</div>
            <div class="content-value">1-888-918-8888</div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <h3 class="content-header"><strong>大多伦多市内交通</strong><span>（公共交通）</span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">万锦市（Markham）</div>
            <div class="content-value">416-394-4636</div>
          </li>
          <li class="content-item">
            <div class="content-label">旺市（Vaughan）</div>
            <div class="content-value">416-832-8527</div>
          </li>
          <li class="content-item">
            <div class="content-label">密西沙加（Markham）</div>
            <div class="content-value">905-615-4636</div>
          </li>
          <li class="content-item">
            <div class="content-label">宾顿（Brampton）</div>
            <div class="content-value">905-874-2999</div>
          </li>
        </ul>
        <h3 class="content-header"><strong>救助热线 </strong><span>（公共交通） </span></h3>
        <ul class="content-list">
          <li class="content-item">
            <div class="content-label">汽车紧急服务 CAA</div>
            <div class="content-value">800-222-4357</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PublicPhone',
  data() {
    return {
      tabIndex: 0,
      tabList: [
        { name: '紧急求救', icon: 'yk-help' },
        { name: '政府资讯', icon: 'yk-government' },
        { name: '电信上网', icon: 'yk-online' },
        { name: '银行服务', icon: 'yk-bank' },
        { name: '日常服务', icon: 'yk-life' },
        { name: '维修挂失', icon: 'yk-repair' },
        { name: '公共交通', icon: 'yk-bus' },
      ],
    };
  },
  mounted() {
    const serviceType = Number(this.$route.query.service_type);
    if (!isNaN(serviceType)) {
      this.tabIndex = serviceType - 1;
      this.$nextTick(() => {
        this.$refs.public.scrollIntoView();
      });
    }
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.public {
  margin-top: 40px;
}
.public-header {
  display: flex;
  margin-bottom: 20px;
}
.public-header__name {
  font-size: 20px;
  line-height: 28px;
  margin-right: 20px;
}
.public-header__tip {
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 17px;
  strong {
    font-weight: 500;
    color: var(--text-color-3);
  }
  span {
    color: var(--text-color-6);
    margin-right: 22px;
  }
}
.public-tab__list {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
}
.public-tab__item {
  width: 150px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f7f9fc;
  font-size: 14px;
  color: #222;
  border-radius: 4px;
  position: relative;
  &::after {
    content: '';
    border-width: 8px 12px;
    border-style: solid;
    border-color: transparent;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
  }
  i {
    margin-right: 5px;
  }
  &.active {
    background-color: var(--primary-color-lightest);
    color: var(--primary-color);
    &::after {
      border-top-color: var(--primary-color-lightest);
    }
  }
  &:hover {
    opacity: 0.8;
  }
}
.content-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  strong {
    font-size: 16px;
    line-height: 22px;
    font-weight: 600;
    color: var(--primary-color);
  }
  span {
    font-size: 14px;
    line-height: 20px;
    color: var(--text-color-9);
  }
}
.content-section {
  display: flex;
  justify-content: space-between;
}
.content-block {
  width: 550px;
}
.content-list {
  margin-bottom: 30px;
}
.content-item {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-3);
  margin-bottom: 10px;
  &:hover {
    background-color: #fcebeb;
  }
}
</style>
